import React, { useState, useEffect, useRef } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { SB } from './sidebarConfig';

export function LanguagePicker({ language, setLanguage, languageNames, collapsed }) {
  const [open, setOpen] = useState(false);
  const bodyRef = useRef(null);
  const containerRef = useRef(null);
  const [h, setH] = useState(0);
  useEffect(() => { if (bodyRef.current) setH(open ? bodyRef.current.scrollHeight : 0); });
  // Auto-scroll parent nav when expanding
  useEffect(() => {
    if (open && containerRef.current) {
      const timer = setTimeout(() => {
        containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 280);
      return () => clearTimeout(timer);
    }
  }, [open]);

  const langs = [
    { key: 'en', label: 'English' },
    { key: 'tg', label: '\u0422\u043e\u04b7\u0438\u043a\u04e3' },
    { key: 'ru', label: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439' },
    { key: 'uz', label: "O'zbek" },
  ];

  return (
    <div ref={containerRef} style={{ marginBottom: 2 }}>
      <button
        onClick={() => setOpen(p => !p)}
        data-testid="language-toggle-btn"
        style={{
          width: '100%', display: 'flex', alignItems: 'center', gap: 10,
          padding: collapsed ? '10px 0' : '9px 12px',
          justifyContent: collapsed ? 'center' : 'flex-start',
          borderRadius: SB.radius, border: 'none', cursor: 'pointer',
          fontSize: 13.5, fontWeight: 500, fontFamily: 'inherit',
          color: SB.muted, background: SB.bg,
          transition: `background ${SB.transition}, color ${SB.transition}`,
          WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation',
        }}
      >
        <span style={{ flexShrink: 0, display: 'flex', color: SB.mutedSoft }}>
          <Globe style={{ width: 17, height: 17 }} />
        </span>
        {!collapsed && (
          <>
            <span style={{ flex: 1, textAlign: 'left' }}>{languageNames?.[language] || 'English'}</span>
            <ChevronDown style={{
              width: 14, height: 14, flexShrink: 0,
              transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
              transition: 'transform 0.2s ease', opacity: 0.4,
            }} />
          </>
        )}
      </button>
      {!collapsed && (
        <div style={{
          height: `${h}px`, overflow: 'hidden',
          transition: 'height 0.25s cubic-bezier(0.4, 0, 0.2, 1)', willChange: 'height',
        }}>
          <div ref={bodyRef} style={{ paddingTop: 2, paddingBottom: 4 }}>
            {langs.map(l => (
              <button
                key={l.key}
                onClick={() => { setLanguage(l.key); setOpen(false); }}
                data-testid={`lang-${l.key}`}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 8,
                  padding: '7px 12px', paddingLeft: 42, borderRadius: 6,
                  fontSize: 13, fontWeight: language === l.key ? 600 : 500,
                  border: 'none', cursor: 'pointer',
                  fontFamily: 'inherit', textAlign: 'left',
                  color: language === l.key ? SB.primary : SB.muted,
                  background: language === l.key ? SB.primaryBg : 'transparent',
                  borderLeft: language === l.key ? `2px solid ${SB.primary}` : '2px solid transparent',
                  transition: `background ${SB.transition}, color ${SB.transition}`,
                  WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation',
                }}
                onMouseEnter={e => { if (language !== l.key) { e.currentTarget.style.background = SB.hoverBg; e.currentTarget.style.color = SB.fg; }}}
                onMouseLeave={e => { if (language !== l.key) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = SB.muted; }}}
              >
                <span>{l.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
